module.exports = __webpack_public_path__ + "media/packs/images/order-again-5e406530261861dc89c912a6fb15c06c.svg";